import React, { useCallback, useMemo } from 'react';
import cx from 'classnames';
import { shape, string, number } from 'prop-types';
import { useSettings } from '@apollo/core';
import { useHistory } from 'react-router-dom';
import { buildCdnUrl, isUrlAbsolute } from '../../../core/utils';

const BannerSliderItem = React.memo(({ bannerData, index, activeIndex }) => {
  const history = useHistory();
  const { isCordova } = useSettings();

  const handleAnchorClick = useCallback(
    (event) => {
      if (!isCordova) {
        return;
      }

      const anchor = event.currentTarget;
      const target = anchor.getAttribute('target');
      const href = anchor.getAttribute('href');

      if (!isUrlAbsolute(href)) {
        event.preventDefault();
        history.push(href);
        return false;
      }

      if (target && target.toLocaleLowerCase() == '_blank') {
        event.preventDefault();
        window.open(href, '_system');
        return false;
      }
    },
    [isCordova],
  );

  const hasMobileImage = useMemo(
    () => !!bannerData.mobile_image_url,
    [bannerData.mobile_image_url],
  );

  const className = cx('banner-slider__slide', {
    active: index === activeIndex,
    'has-mobile-img': hasMobileImage,
  });

  // const cleanHtml = { __html: DOMPurify.sanitize(bannerData.description, { KEEP_CONTENT: true }) };

  const imgElem = useMemo(
    () => (
      <>
        <img
          className='banner-slider__slide_img banner-slider__slide_img--desktop'
          src={buildCdnUrl(bannerData.image_url, 'LOGOS_CDN_URL')}
          alt={bannerData.title}
          loading='lazy'
        />
        {hasMobileImage && (
          <img
            className='banner-slider__slide_img banner-slider__slide_img--mobile'
            src={buildCdnUrl(bannerData.mobile_image_url, 'LOGOS_CDN_URL')}
            alt={bannerData.title}
            loading='lazy'
          />
        )}
      </>
    ),
    [bannerData.image_url, bannerData.mobile_image_url, bannerData.title, hasMobileImage],
  );

  if (bannerData.action_url) {
    return (
      <a
        className={className}
        href={bannerData.action_url}
        target={bannerData.action_url_target || '_self'}
        onClick={handleAnchorClick}
      >
        {imgElem}
      </a>
    );
  }
  return <div className={className}>{imgElem}</div>;
});

BannerSliderItem.propTypes = {
  index: number.isRequired,
  activeIndex: number.isRequired,
  bannerData: shape({
    title: string.isRequired,
    image_url: string.isRequired,
    mobile_image_url: string,
    description: string.isRequired,
  }).isRequired,
};

export default BannerSliderItem;
